import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';

import { loginReducer } from './redux/reducers/authReducers';
import { createPurchaseOrderReducer, deletePurchaseOrderReducer, getPurchaseOrderReducer, getVendorPurchaseOrderReducer, updatePurchaseOrderReducer, generatePdfReducer, getSelectedPOReducer } from './redux/reducers/purchaseOrderReducers';
import { createBillReducer, deleteBillReducer, getBillsReducer, updateBillReducer, getPenaltiesReducer } from './redux/reducers/billReducers';
import { createPaymentReducer, deletePaymentReducer, getPaymentsReducer, updatePaymentReducer } from './redux/reducers/paymentReducers';
import { createBranchReducer, deleteBranchReducer, getBranchReducer, updateBranchReducer } from './redux/reducers/branchMasterReducers'
import { createExpenseReducer, deleteExpenseReducer, getExpenseReducer, updateExpenseReducer } from './redux/reducers/expenseMasterReducers';
import { createVendorReducer, deleteVendorReducer, getVendorReducer, updateVendorReducer } from './redux/reducers/vendorMasterReducers';
import { approveBillsReducer, approvePaymentsReducer, rejectBillsReducer, rejectPaymentsReducer } from './redux/reducers/approvalReducers';

const reducer = combineReducers({
    loginData: loginReducer,

    getPurchaseOrderData: getPurchaseOrderReducer,
    createPurchaseOrderData: createPurchaseOrderReducer,
    updatePurchaseOrderData: updatePurchaseOrderReducer,
    deletePurchaseOrderData: deletePurchaseOrderReducer,
    getVendorPurchaseOrderData: getVendorPurchaseOrderReducer,
    getSelectedPurchaseOrderData: getSelectedPOReducer,
    generatePdfData: generatePdfReducer,

    getBillsData: getBillsReducer,
    createBillData: createBillReducer,
    updateBillData: updateBillReducer,
    deleteBillData: deleteBillReducer,
    getPenaltiesData: getPenaltiesReducer,

    getPaymentsData: getPaymentsReducer,
    createPaymentData: createPaymentReducer,
    updatePaymentData: updatePaymentReducer,
    deletePaymentData: deletePaymentReducer,

    getBranchData: getBranchReducer,
    createBranchData: createBranchReducer,
    updateBranchData: updateBranchReducer,
    deleteBranchData: deleteBranchReducer,

    getExpenseData: getExpenseReducer,
    createExpenseData: createExpenseReducer,
    updateExpenseData: updateExpenseReducer,
    deleteExpenseData: deleteExpenseReducer,

    getVendorData: getVendorReducer,
    createVendorData: createVendorReducer,
    updateVendorData: updateVendorReducer,
    deleteVendorData: deleteVendorReducer,

    approveBillsData: approveBillsReducer,
    rejectBillsData: rejectBillsReducer,
    approvePaymentsData: approvePaymentsReducer,
    rejectPaymentsData: rejectPaymentsReducer

})

const middleware = [thunk];
const initialState = {};

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    reducer,
    initialState,
    composeEnhancer(applyMiddleware(...middleware))
)

export default store;